import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Recruit } from "../lib/api";
import { hasKey } from "../lib/settings";
import { supabase } from "../lib/supabase";
import { LogOut } from "lucide-react";

export default function Nav() {
  const { pathname } = useLocation();
  const [trial, setTrial] = useState(null);
  const [keyed, setKeyed] = useState(hasKey());

  useEffect(() => {
    // Only fetch trial/credits status if logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        Recruit.trialStatus().then(setTrial).catch(() => {});
      }
    });
    setKeyed(hasKey());
  }, [pathname]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  const link = (to, label, tid) => {
    const active = pathname === to || (to !== "/" && to !== "/app" && pathname.startsWith(to)) || (to === "/app" && pathname === "/app");
    return (
      <Link
        to={to}
        data-testid={tid}
        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
          active 
            ? "bg-haze text-ink" 
            : "text-sub hover:text-ink"
        }`}
      >
        {label}
      </Link>
    );
  };

  return (
    <header className="frost border-b hairline sticky top-0 z-30" data-testid="top-nav">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-3.5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <div className="w-8 h-8 rounded-xl bg-ink text-white flex items-center justify-center font-semibold text-sm">
            R
          </div>
          <div className="font-semibold tracking-tighter2 text-[17px] leading-none text-ink">
            Recruit<span className="text-accent">.</span>IQ
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          {link("/app", "Projects", "nav-projects")}
          {link("/app/new", "New", "nav-new")}
          {link("/app/settings", "Settings", "nav-settings")}
        </nav>

        <div className="flex items-center gap-3">
          {!keyed && trial && (
            <Link 
              to="/app/settings" 
              data-testid="trial-pill"
              className={`text-xs font-medium px-3 py-1.5 rounded-full ${
                trial.remaining > 0 
                  ? "bg-accentSoft text-accent" 
                  : "bg-danger/10 text-danger"
              }`}
            >
              {trial.remaining > 0 ? `${trial.remaining} free run${trial.remaining === 1 ? "" : "s"} left` : "Trial used — add key"}
            </Link>
          )}
          {keyed && (
            <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-success/10 text-success" data-testid="key-pill">
              ● Your key
            </span>
          )}
          
          <button
            onClick={handleLogout}
            title="Log Out"
            className="p-1.5 border hairline rounded-full hover:bg-haze text-ink transition-colors flex items-center justify-center"
          >
            <LogOut className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </header>
  );
}
